// import {setCookie} from '../common/cookie';
import axios from 'axios'
import { getCookie } from "common/util/cookie";

export const Api = {
    baseUrl: process.env.REACT_APP_API_URL,
    pcUrl: process.env.REACT_APP_PC_URL,
    cartUrl: process.env.REACT_APP_CART_URL,

    getMallInfo: function (mall_name) {
        let _url = this.baseUrl + '/common/information/manager/?mall_web_user=' + mall_name
        return axios.get(_url)
    },

    getMallInfoToNumber: function (idx_b_manager) {
        let _url = this.baseUrl + `/common/information/manager/${idx_b_manager}`
        return axios.get(_url)
    },

    getCategorys: function () {
        let _url = this.baseUrl + '/front/v1/item/getCate/'
        return axios.get(_url)
    },

    getTalkEstimate: function (talk_id) {
        let _url = this.baseUrl + '/front/v1/estimate/talk?talk_id=' + talk_id
        return axios.get(_url)
    },

    getHotdeal: function (cate) {
        let _url = this.baseUrl + '/front/v1/event/hotdeal/' + cate
        return axios.get(_url)
    },

    getMinishop: function (cate_id, item_id) {
        let _url =
            this.baseUrl + '/front/v1/item/getMinishop/?cate_id=' + cate_id + '&item_id=' + item_id + '&stdpcYN=N'
        return axios.get(_url)
    },

    // getItems:function(cate, nowpage, pagecount, sortkey, price_type, body, shopID){
    //     // store가 있을경우 idx_b_manager은 무시됨
    // 	let _url = this.baseUrl+"/front/v1/item/list/"+cate+"/?nowpage="+nowpage+"&pagecount="+pagecount
    // 	+"&totalcount=0&sortkey="+sortkey+"&price_type="+price_type+"&idx_b_manager=1&sale=N";
    //     if (shopID) _url = _url+'&store='+shopID
    // 	return axios.post(_url, body);
    // },

    getItemsParam: function (params, body) {
        // cate, nowpage, pagecount, sortkey, price_type, body, shopID
        let getParams = []
        if (!params.cate) return false

        if (params.nowpage) getParams.push('nowpage=' + params.nowpage)
        else getParams.push('nowpage=1')

        if (params.pagecount) getParams.push('pagecount=' + params.pagecount)
        else getParams.push('pagecount=10')

        if (params.totalcount) getParams.push('totalcount=' + params.totalcount)
        else getParams.push('totalcount=0')

        if (params.sortkey) getParams.push('sortkey=' + params.sortkey)
        else getParams.push('sortkey=1')

        if (params.price_type) getParams.push('price_type=' + params.price_type)
        else getParams.push('price_type=cash')

        if (params.idx_b_manager) getParams.push('idx_b_manager=' + params.idx_b_manager)
        else getParams.push('idx_b_manager=1')

        if (params.sale) getParams.push('sale=' + params.sale)
        else getParams.push('sale=N')

        // store가 있을경우 idx_b_manager은 무시됨
        if (params.store) getParams.push('store=' + params.store)

        if (params.adv) getParams.push('adv=' + params.adv)

        let _url = this.baseUrl + '/front/v1/item/list/' + params.cate + '/?' + getParams.join('&')
        return axios.post(_url, body)
    },

    getItemCount: function (cate, body, shopID) {
        let _url = this.baseUrl + '/front/v1/item/listCount/' + cate + '/?idx_b_manager=1&sale=N&price_type=cash'
        if (shopID) _url = _url + '&store=' + shopID
        return axios.post(_url, body)
    },

    getSpecs: function (cate) {
        let _url = this.baseUrl + '/front/v1/item/spec/' + cate
        return axios.get(_url)
    },

    getStdpcSpecs: function (item_id) {
        let _url = this.baseUrl + '/front/v1/stdpc/items/' + item_id
        return axios.get(_url)
    },

    getPrice: function (cate) {
        let _url = this.baseUrl + '/front/v1/item/getSchPrice/?cate_id=' + cate
        return axios.get(_url)
    },

    getEstimateList: function (itemList, type, mallID, stdpc, soldout) {
        let mallQuery = '&mallID=1'
        let stdpcQuery = ''
        let cashQuery = 'priceType=cash'
        let includeSoldout = '&includeSoldout=N'
        if (type) cashQuery = 'priceType=' + type
        if (mallID) mallQuery = '&mallID=' + mallID
        if (stdpc) stdpcQuery = '&stdpcInfoItemID=' + stdpc
        if (soldout) includeSoldout = '&includeSoldout=' + soldout

        let _url =
            this.baseUrl +
            '/front/v1/estimate/list?' +
            cashQuery +
            '&itemList=' +
            itemList +
            mallQuery +
            stdpcQuery +
            includeSoldout
        return axios.get(_url)
    },

    getAdver: function (cate_id, adtype, idx_b_manager) {
        let adType = '?adtype=' + adtype
        let b_manager = idx_b_manager && '&idx_b_manager=' + idx_b_manager
        let _url = this.baseUrl + '/front/v1/adver/' + cate_id + adType + b_manager
        return axios.get(_url)
    },

    getCurationAd: function () {
        let _url = this.baseUrl + '/front/v1/curation/estimate'
        return axios.get(_url)
    },

    getEvent: function (cate_id) {
        let _url = this.baseUrl + '/front/v1/event/category/' + cate_id
        return axios.get(_url)
    },

    getMediumGuide: function (cate_id) {
        let _url = this.baseUrl + '/front/v1/medium/view/' + cate_id
        return axios.get(_url)
    },

    getCuration: function (cate_id) {
        let _url = this.baseUrl + '/front/v1/item/CurationList/' + cate_id
        return axios.get(_url)
    },

    saveEstimateList: function (opt, params) {
        let _url = this.baseUrl + '/front/v1/estimate/sheet'
        axios.post(_url, params).then((rst) => {
            let data = rst.data.result
            let _url = ''
            if (opt === 'estpc') {
                _url = 'http://talk.pping.kr/estpc/c/' + data
            } else if (opt === 'dauc') {
                _url = 'http://talk.pping.kr/dauc/c/' + data
            }
            if (_url) {
                window.open(_url)
            }
        })
    },

    saveEstimates: function (params) {
        // let fd = new FormData(document.getElementById('estimateListForm'));
        var _url = this.baseUrl + '/front/v1/estimate/sheet'
        return axios.post(_url, params)
    },

    addBasket: function (shopNO, userID, itemList) {
        let _url = this.baseUrl + '/front/v1/cart/regist/' + shopNO + '/' + userID

        let items = []
        for (let i in itemList) {
            let row = {}
            row['item_id'] = itemList[i].itemID
            row['cnt_item'] = itemList[i].count
            row['f_item'] = 0
            row['f_route'] = 0
            row['idx_est_prt'] = 0

            items.push(row)
        }

        let param = {}
        param.items = items

        return axios.post(_url, param)
    },

    getStdpc: function (getCount) {
        if (typeof getCount === 'undefined') {
            getCount = 3
        }
        var _url = this.baseUrl + '/front/v1/item/mainstdpc?getCount=' + getCount
        return axios.get(_url)
    },

    getNoitce:function(b_manager){
        let _url = this.baseUrl+"/front/v2/board/main/notice";
        if (b_manager !== undefined) _url += '/'+b_manager
        return axios.get(_url);
    },
    /**
     * 미니샵 찜하기
     * @param idx_member
     * @param idx_b_manager
     * @param zzim_state 1: 찜 등록, 2: 찜 삭제
     * @returns {Promise<AxiosResponse<any>>}
     */
    updateMinishopZzim: function(idx_member, idx_b_manager, zzim_state) {
        let _url = `${this.baseUrl}/common/information/manager/minishopzzim/${idx_b_manager}/${idx_member}?zzim_state=${zzim_state}`
        return axios.get(_url)
    },

    getUserInfo: function() {
        let _url = this.baseUrl + '/front/v2/user/info'
        const auth_token = getCookie('auth_token')
        let config = {
            // headers: {'X-CSRF-TOKEN': getCookie('XSRF-TOKEN')},
            withCredentials: true,
            xsrfHeaderName: 'Authorization',
        }
        return axios.post(_url, { auth_token }, config)
    },
}



// WEBPACK FOOTER //
// ./src/basic/libs/api.js